export default {
  1: 'mdi-emoticon-dead',
  2: 'mdi-emoticon-sad-outline',
  3: 'mdi-emoticon-neutral-outline',
  4: 'mdi-emoticon-happy-outline',
  5: 'mdi-emoticon-cool-outline',
}